import React from 'react'
import ImagePreviewSpace from './ImagePreviewSpace'
import c from './ImagePreview.module.scss'

interface ImagePreviewProps {
  imageUrl: string | null
}

function ImagePreview({ imageUrl }: ImagePreviewProps) {
  if (imageUrl) {
    return (
      <div className={c.container}>
        <ImagePreviewSpace imageUrl={imageUrl} />
      </div>
    )
  }

  return null
}

export default ImagePreview
